import React, { useEffect, useState } from "react";
import Profile from "./Profile";
import AllDocumentsList from "./AllDocumentsList";
import Leaves from "../../../../features/portal/leaves/Leaves";
import JoiningDetailsForm from "./JoiningDetailsForm";
import UploadDocuments from "./UploadDocuments";
import Policies from "./Policy";
import { useDispatch, useSelector } from "react-redux";
import { setActiveMenu } from "../../../../redux/slice/activeMenuSlice";
import { toast } from "react-toastify";

export default function MyDetails() {
    const dispatch = useDispatch();
    const { isPolicyAccepted, isJoiningFormCompleted, isExistingEmp } = useSelector((state) => state?.persistedReducer?.forms?.savedPermissions) || {}

    const activeMenu = useSelector(state => {
        const storedMenu = state.activeMenu.menu;
        if (storedMenu) return storedMenu;
        if (!isJoiningFormCompleted) return "myjoiningdetails";
        if (isExistingEmp) return "uploaddocuments";
        if (!isPolicyAccepted) return "policies";
        return "profile";
    });
    const currentRole = localStorage.getItem("role")
    const isSuperAdmin = currentRole === "SUPER_ADMIN"
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [navMenu, setNavMenu] = useState(["Profile", "My Documents", "Policies"])

    useEffect(() => {
        const isDev = process.env.NODE_ENV === "development";
        const isEnvEnabled = process.env.REACT_APP_ENABLE_ALL_STEPS === "true";
        const isTesting = isDev && isEnvEnabled;
        let updatedMenu = ["Profile", "My Documents"];
        let isCompletedDetail;
        if (isTesting) {
            isCompletedDetail = !isJoiningFormCompleted;
            updatedMenu.push("My Joining Details");
        } else {
            isCompletedDetail = isJoiningFormCompleted;
        }
        if (!isCompletedDetail && !updatedMenu.includes("My Joining Details")) {

            updatedMenu.push("My Joining Details");
        }
        if (activeMenu === "myjoiningdetails" && !updatedMenu.includes("My Joining Details")) {
            updatedMenu.push("My Joining Details");
        }

        if (isExistingEmp) {
            updatedMenu.push("Upload Documents");
        }

        updatedMenu.push("Policies");
        setNavMenu(updatedMenu);
    }, [isJoiningFormCompleted, isExistingEmp]);
    const handleNavClick = (menu) => {
        const targetMenu = menu.toLowerCase().replaceAll(" ", "");
        const isNotRestrictedMenu = ["policies", "myjoiningdetails", "uploaddocuments"].includes(targetMenu);
        if ((isPolicyAccepted && isJoiningFormCompleted && !isExistingEmp) || isNotRestrictedMenu || isSuperAdmin) {
            dispatch(setActiveMenu({ menu: menu.toLowerCase().replaceAll(" ", ""), subMenu: "summary" }));
            setIsMenuOpen(false);
        }
        else {
            toast.error(`Please complete${isExistingEmp ? ' Upload Documents,' : ""} 'My Joining Details' and 'Policies' to access other sections.`, { className: "toast-error-custom", });
        }
    };

    const renderContent = () => {
        switch (activeMenu) {
            case "profile": return <div className="profile-container"><Profile /></div>;
            case "leaves": return <div className="profile-container"><Leaves /></div>;
            case "skilldetails": return <div className="profile-container"><h5>Skill details here...</h5></div>;
            case "myapprovals": return <div className="profile-container"><h5>My Approvals...</h5></div>;
            case "mydocuments": return <div className="profile-container"><AllDocumentsList /></div>;
            case "myjoiningdetails": return <div><JoiningDetailsForm /></div>;
            case "uploaddocuments": return <div><UploadDocuments /></div>;
            case "inbox": return <div className="profile-container"><h3>Inbox...</h3></div>;
            case "policies": return <div><Policies /></div>;
            default: return <div className="profile-container"><Profile /></div>;
        }
    };

    return (
        <div className="container-fluid">
            <div className={`navbar-wrapper ${isMenuOpen ? "menu-open" : "menu-close"}`}>
                {/* <div className="navbar-wrapper d-flex justify-content-between align-items-center"> */}
                <button type="button" className="menu-toggle-btn" onClick={() => setIsMenuOpen(!isMenuOpen)} >
                    <i className={`bi text-white ${isMenuOpen ? 'bi-x-lg' : 'bi-list'} hamburger-icon`}></i>
                </button>
                {/* Mobile Current Title */}
                <span className="mobile-current-title d-md-none text-white mr-3">
                    {navMenu.find(menu => menu.toLowerCase().replaceAll(" ", "") === activeMenu) || "Profile"}
                </span>
                <div className={`navbar-container ${isMenuOpen ? "show" : ""}`}>
                    {navMenu.map(menu => {
                        const menuKey = menu.toLowerCase().replaceAll(" ", "");
                        const isNotRestricted = ["policies", "myjoiningdetails", "uploaddocuments"].includes(menuKey);
                        const requirementsMet = isPolicyAccepted && isJoiningFormCompleted && !isExistingEmp;
                        const isDisabled = !isNotRestricted && !requirementsMet && !isSuperAdmin;
                        return (
                            <button
                                type="button"
                                key={menu}
                                // disabled={isDisabled}
                                className={`btn-interactive nav-link ${activeMenu === menu.toLowerCase().replaceAll(" ", "") ? "active" : ""}`}
                                onClick={(e) => { e.preventDefault(); handleNavClick(menu); }}
                                style={{
                                    cursor: !isDisabled ? "pointer" : "not-allowed",
                                    opacity: !isDisabled ? 1 : 0.5
                                }}
                            >
                                {menu}
                            </button>
                        )
                    })}
                </div>
            </div>
            {renderContent()}
        </div>
    );
}
